import {extendComponent} from "juis-components/ComponentUtils.js";
import Component from "juis-components/Component.js";

export default extendComponent(Component, function () {

}, [], "HR");
